(() => {
  const body = document.body;
  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !menuToggle) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menuToggle.setAttribute('aria-expanded', String(open));
    body.classList.toggle('menu-open', open);
    if (open) menuClose?.focus(); else menuToggle.focus();
  };

  menuToggle?.addEventListener('click', () => setMenu(true));
  menuClose?.addEventListener('click', () => setMenu(false));
  menu?.addEventListener('click', (event) => {
    if (event.target === menu) setMenu(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) setMenu(false);
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const activateProductMedia = (section, mediaId) => {
    if (!section || !mediaId) return;
    section.querySelectorAll('[data-media-id]').forEach((media) => {
      const active = media.dataset.mediaId === String(mediaId);
      media.classList.toggle('is-selected', active);
      media.hidden = !active;
    });
    section.querySelectorAll('[data-media-thumb]').forEach((thumbnail) => {
      const active = thumbnail.dataset.mediaTarget === String(mediaId);
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-pressed', String(active));
    });
  };

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const section = gallery.closest('[data-product-section]');
    gallery.querySelectorAll('[data-media-thumb]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => activateProductMedia(section, thumbnail.dataset.mediaTarget));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const section = select.closest('[data-product-section]');
    const price = section?.querySelector('[data-product-price]');
    const compare = section?.querySelector('[data-compare-price]');
    const button = section?.querySelector('[data-add-to-cart]');
    const buttonText = section?.querySelector('[data-add-to-cart-text]');
    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice || option.dataset.comparePrice === option.dataset.price;
      }
      if (button) button.disabled = !available;
      if (buttonText) buttonText.textContent = available ? (button?.dataset.addLabel || 'Add to cart') : (button?.dataset.soldLabel || 'Sold out');
      if (option.dataset.mediaId) activateProductMedia(section, option.dataset.mediaId);
      if (section?.querySelector('[data-product-gallery]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    };
    select.addEventListener('change', updateVariant);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  if (body.classList.contains('motion-enabled') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealItems = document.querySelectorAll('main > .shopify-section');
    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in-view');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    revealItems.forEach((item) => {
      item.classList.add('reveal-ready');
      observer.observe(item);
    });
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.manual === 'true') return;
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
